import GeneralDelay from './GeneralDelay';

export default GeneralDelay;
